__turbopack_context__.v({
  "sellerNavigation": "styles-module__hUirlq__sellerNavigation",
});
